var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 91,
  height: 90,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDC500",
  d: "M90.666 45c0-24.853-20.147-45-45-45s-45 20.147-45 45 20.147 45 45 45 45-20.147 45-45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#794B37",
  d: "M18.71 66.536c15.68-1.38 33.822-2.006 49.557-1.612l4.354 3.555s-1.076 3.277-2.31 5.16c-.285.435-.585.885-1.024 1.158-.472.297-1.046.36-1.601.417a276 276 0 0 1-28.793 1.372c-6.195-.03-13.15-.607-17.2-5.295l-2.975-4.755z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#171717",
  d: "M47.36 64.999h-3.385V14.692a1.282 1.282 0 0 1 2.565-.022l.825 50.329z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M48.607 15.919c-.199-.39-.788-.237-.773.202.488 14.393.443 28.785.979 43.178.019.483.045 1.005.259 1.38.273.483.761.573 1.196.622a53.8 53.8 0 0 0 18.334-1.162C64.927 48.13 63.659 45.956 58.184 34.54L48.603 15.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D73823",
  d: "M62.92 44.497c-.994-2.19-2.149-4.582-3.657-7.71-4.102.135-8.396.147-10.972.143q.066 4.032.139 8.062c3.412.12 9.618-.19 14.486-.495zM48.066 24.712c.06 2.693.113 5.39.158 8.082 2.295.045 5.756-.154 8.865-.387l-3.986-7.747c-1.898.045-3.687.052-5.037.052M67.457 56.486c-.998-3.112-1.834-5.49-2.708-7.687-5.527.352-13.061.356-16.237.34.06 2.678.135 5.352.225 8.03 3.926.258 13.488-.323 18.716-.683z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.026 30.952c.262-.37.847-.172.825.285-.48 10.16-.443 20.314-.98 30.473-.018.345-.044.716-.262.982-.277.345-.772.41-1.215.443a77.3 77.3 0 0 1-17.947-.72.462.462 0 0 1-.326-.686 396 396 0 0 1 15.405-24.402l4.496-6.375z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D73823",
  d: "M33.1 43.95a383 383 0 0 0-3.694 5.749c4.444.259 10.388.532 12.889.341q.074-3 .142-6c-1.78.008-5.606.011-9.337-.09M27.42 52.89a380 380 0 0 0-3.44 5.677c3.36.23 15.188.987 18.012.563q.128-2.97.217-5.94c-1.781.011-9.66.052-14.79-.3M42.517 40.905c.053-2.006.11-4.013.184-6.023-.802.004-2.032.008-3.442-.01l-1.73 2.452a381 381 0 0 0-2.283 3.382c2.76.18 5.693.308 7.275.195z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.666 0h90v90h-90z"
})))));
export { SvgAvatar2 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-2.7089068e659215a3120b.svg";